<priva-header class="margin-vertical-2" [title]="title() | translate" size="xl" heading="h1" />
<priva-well class="wizard__main">
    <ng-content />
</priva-well>
